import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectionComponent } from './language-selection/language-selection.component';
import { OnboardingLoginComponent } from './login/onboarding-login.component';
import { TermsAndConditionsSelectionComponent } from './terms-and-conditions-selection/terms-and-conditions-selection.component';

@NgModule({
    imports: [CommonModule, TranslateModule, IonicModule, MatIconModule],
    exports: [LanguageSelectionComponent, TermsAndConditionsSelectionComponent, OnboardingLoginComponent],
    declarations: [LanguageSelectionComponent, TermsAndConditionsSelectionComponent, OnboardingLoginComponent]
})
export class OnboardingModule {}
